export default {
    PENDING_REQUEST_TIMEOUT: 60000,
};
